import globalDomains from '@/utils/global-domains';
import {checkAdvertisementBlocking} from '@/utils/main';

/**
 * id 작성하실때 body 내부랑 겹치지 않게 하기 위해 head 시작 해주시길 바랍니다.
 * @type {[{tag: string, id: string, attribute: [{value: string, key: string}]}]}
 */
export const DYNAMIC_TAG_LIST = [
  /**
   * TODO: 깜박임이 심하거나, 네트워크 속도 이슈로 pm 파일이 늦게 로드가 될 경우를 대비해서, pm 이 로드가 된 후, body 내용도 랜더링이 되도록 진행 될 수 있음
   *
   * */
  // {
  //   tag: 'script',
  //   id: 'common-pm-js',
  //   isLoad: false,
  //   attribute: [
  //     {key: 'type', value: 'text/javascript'},
  //     {
  //       key: 'src',
  //       value: `${globalDomains.RES_AFREECATV}/script/new_main/common_pm.js`,
  //     },
  //   ],
  //   callback: (isRender, setRenderCallback) => {
  //   setRenderCallback(!isRender)
  // },
  // },
  {
    tag: 'script',
    id: 'constant',
    isLoad: false,
    attribute: [
      {key: 'type', value: 'text/javascript'},
      {
        key: 'src',
        value: `${globalDomains.STATIC_AFREECATV}/asset/service/config/constant.js`,
      },
    ],
  },
  {
    tag: 'script',
    id: 'common-js',
    isLoad: true,
    attribute: [
      {key: 'type', value: 'text/javascript'},
      {
        key: 'src',
        value: `${globalDomains.RES_AFREECATV}/script/new_main/common.js`,
      },
    ],
    callback: () => {
      window.registerNotification && window.registerNotification();
    },
  },
  {
    tag: 'script',
    id: 'maintenance-service',
    isLoad: true,
    attribute: [
      {key: 'type', value: 'text/javascript'},
      {
        key: 'src',
        value: `${globalDomains.RES_AFREECATV}/script/player/service-maintenance.js`,
      },
    ],
    callback: () => {
      // 이 콜백이 실행되는 시점에 window.checkBlock가 바인딩 되지 않는 경우가 있어 해당 타이밍을 기다리는 setTimer
      setTimeout(() => {
        checkAdvertisementBlocking(); // 최초 1회 호출
      }, 0);
    },
  },
];
